import request from 'src/api'
import { orderFirstDataColumn } from 'src/datatableControl'
import { clientFunctions } from 'packs/clients/functions'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { addToast } from 'src/toasts'
import { camelize } from 'src/misc'
import { showGoogleMap } from 'src/googleMap'
import initDatatableChrome from 'src/datatableChrome'
import onIndexRefresh from 'src/indexRefresh'

export default () => {
  clientFunctions()

	// datatable init
  let clientsDatatable = $('#clients-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('clientsIndexPageLength') || 25),
    "processing": true,
    "order": orderFirstDataColumn(),
    "serverSide": true,
    "ajax": {
      "url": $('#clients-datatable').data('source')
    },
    "columns": [
      { "data": "company_name" },
      { "data": "business_id" },
      { "data": "status" },
      { "data": "contact_person" },
      { "data": "phone" },
      { "data": "email" },
      { "data": "address" },
      { "data": "actions", "orderable": false, "className": "all" }
    ],
    initComplete(settings, json) {
      initDatatableChrome('clients-datatable')

  	}
  })

  // T-102 / T-108 / U-48: reload this page's table when a save says so. The `off()`/`on()` pair and
  // `resetPaging: false` live in `src/indexRefresh` — five packs carried a copy of both.
  onIndexRefresh('clientsIndex', clientsDatatable)

  $('#content').on('change', "[name='clients-datatable_length']", function() {
    localStorage.setItem('clientsIndexPageLength', $(this).val())
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    clientsDatatable.search('').draw()
  })

  $('#content').on('click', '#add_client', function() {
    lockButton('#add_client')
    offcanvasRight.show()
    $.getScript('/clients/new')
  })

  $('#content').on('click', '.show-googlemap', function(event) {
    $(this).prop("disabled", true)

    const companyName = $(this).data('company_name')
    const streetName = $(this).data('street_name')
    const postCode = $(this).data('post_code')
    const town = $(this).data('town')
    const country = $(this).data('country')
    const totalAddress = (streetName + ", " + postCode + " " + town).trim()
    if (totalAddress.length > 1) {
      let title = companyName
      showGoogleMap(mainModal, title, [{ address: totalAddress + ', ' + country, title: totalAddress }])
    } else {
      addToast(I18n.t("errors.no_address"), 'alert')
    }

    $(this).prop("disabled", false)
  })
}
